import { useQueryClient } from '@tanstack/react-query'
import debounce from 'lodash/debounce'
import { useCallback, useEffect, useMemo } from 'react'
import { REQUESTS_DATA_SOURCE_QUERY_KEY } from '@omnea-app/fe-requests/useRequestsDataSource'
import { REQUESTS_MOBILE_INFINITE_QUERY_KEY } from '@omnea-app/fe-requests/useRequestsMobileInfiniteQuery'
import { taskQueryKeys } from '@omnea-app/fe-tasks/queryKeys'

const DEBOUNCE_TIME = 1000

export const useInvalidateRequestsAndTasksQueries = () => {
  const queryClient = useQueryClient()

  const invalidateQueries = useCallback(() => {
    void queryClient.invalidateQueries({ queryKey: taskQueryKeys.all })
    void queryClient.invalidateQueries({
      queryKey: ['dashboard-requests'],
    })
    void queryClient.invalidateQueries({
      queryKey: ['dashboard-requests-stats'],
    })
    void queryClient.invalidateQueries({ queryKey: [REQUESTS_DATA_SOURCE_QUERY_KEY] })
    void queryClient.invalidateQueries({ queryKey: [REQUESTS_MOBILE_INFINITE_QUERY_KEY] })
  }, [queryClient])

  const debouncedInvalidateQueries = useMemo(() => debounce(invalidateQueries, DEBOUNCE_TIME), [invalidateQueries])

  useEffect(() => {
    return () => {
      debouncedInvalidateQueries.cancel()
    }
  }, [debouncedInvalidateQueries])

  return debouncedInvalidateQueries
}
